import { render } from "./OpenHw.vue?vue&type=template&id=5b2f95e4"
import script from "./OpenHw.vue?vue&type=script&lang=js"
export * from "./OpenHw.vue?vue&type=script&lang=js"

import "./OpenHw.vue?vue&type=style&index=0&id=5b2f95e4&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__